/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from 'react'; // we need this to make JSX compile
import { Logger } from '../../../../libs/utils/logger';
import { BusinessUserSignup } from './BusinessUserSignup';
import { Grid } from '@mui/material';
import { HeaderSignup } from '../HeaderSignup';
import { CustomerType } from '../../../../types/common.interfaces';

/**
 * Component: BusinessUserSignup
 */

Logger.debug("BusinessUserSignupWrapper.tsx", "Business User Signup Wrapper initializing")

/**
 * Used to call /customer api and passing data to BusinessUserSignup 
 */

export const BusinessUserSignupWrapper: React.FC<any> = React.memo(() => {
        const source = {
            url: "",
            method: "GET",
            data: {}
          } 
         return (
          <Grid item container xs={12}>
            <HeaderSignup percentage={60} logoutIconRequired={true} customerType={CustomerType.BUSINESS}/>
            <Grid item container xs={12}>
              <BusinessUserSignup source={source} id={"business-user-singup"}/>
            </Grid>
          </Grid>
        );
    })
